import { render, staticRenderFns } from "./ledger-live-intro.vue?vue&type=template&id=431e0dbe&"
import script from "./ledger-live-intro.vue?vue&type=script&lang=js&"
export * from "./ledger-live-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports